"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var dateHelper_1 = require("../../../helpers/dateHelper");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var LastUpdatedDate = function (_a) {
    var lastUpdatedDate = _a.lastUpdatedDate;
    return (react_1.default.createElement("span", { className: styles_module_scss_1.default.publish_date },
        react_1.default.createElement("i", { className: "icon-calendar" }),
        dateHelper_1.formatDate(lastUpdatedDate)));
};
exports.default = LastUpdatedDate;
